module.exports = __webpack_public_path__ + "fonts/Gotham-Medium.733d49c9.ttf";